import { INFO_COLOR_BODY } from "../../../../Data/Bonus Ui/BasicCard";
import CommonCard from "../Common/CommonCard";

const InfoColorBody = () => {
  return (
    <>
      {INFO_COLOR_BODY.map((item, index) => (
        <CommonCard key={index} data={item} />
      ))}
    </>
  )
}

export default InfoColorBody